import { apiGet, apiPatch } from './client';
import type {
  PublishedFundRate,
  PublishedFundRateBatchRequest,
} from '../types/PublishedFundRate';

function buildQuery(fromDate?: string, toDate?: string): string {
  const params = new URLSearchParams();
  if (fromDate) params.set('fromDate', fromDate);
  if (toDate) params.set('toDate', toDate);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export function getPublishedFundRates(
  fromDate?: string,
  toDate?: string,
): Promise<PublishedFundRate[]> {
  return apiGet<PublishedFundRate[]>(
    `/api/published-fund-rates${buildQuery(fromDate, toDate)}`,
  );
}

export function savePublishedFundRatesBatch(
  added: PublishedFundRate[],
  modified: PublishedFundRate[],
  deletedIds: number[],
  fromDate?: string,
  toDate?: string,
): Promise<PublishedFundRate[]> {
  return apiPatch<PublishedFundRateBatchRequest, PublishedFundRate[]>(
    '/api/published-fund-rates/batch',
    {
      added,
      modified,
      deleted: deletedIds,
      fromDate,
      toDate,
    },
  );
}
